import { PackageCategoryType } from "../types/loadedData";

export const tourPackageOptions = [
  {
    title: "Attraction ticket",
    description: "Entry to a landmark theme park show",
    _id: "ticket",
  },
  {
    title: "Tour",
    description: "Guided walking tour, day trip, city cruise",
    _id: "tour",
  },
  {
    title: "City card",
    description: "A pass for multiple attraction or transport within a city",
    _id: "city",
  },
  {
    title: "Hop-on Hop-off ticket",
    description: "Entry to a hop-on hop-off bus or boat",
    _id: "hop-on",
  },
  {
    title: "Transfer",
    description: "Transportation services such as airport or bus transfers",
    _id: "transfer",
  },
  {
    title: "Rental",
    description: "Modes of transports, sports euipment, Wi-Fi routers",
    _id: "rental",
  },
  {
    title: "Order",
    description: "Multiple activities sold together",
    _id: "order",
  },
];

export const tourPackageGuideOptions: PackageCategoryType[] = [
  {
    title: "Nobody",
    _id: "nobody",
  },
  {
    title: "Tour guide",
    description:
      "Leads a group of customers through a tour and explains things about the destination or attraction.",
    _id: "guide",
  },
  {
    title: "Host or greeter",
    description:
      "Provides an introduction, purchases a ticket, or waits in line with customers, but doesn't provide a full tour of the attraction.",
    _id: "host",
  },
  {
    title: "Instructor",
    description:
      "Shows customers how to use equipment or teaches them how to do something.",
    _id: "instructor",
  },
  {
    title: "Driver",
    description:
      "Drives the customer somewhere but doesn’t explain anything along the way.",
    _id: "driver",
  },
];
